import React, { useState } from "react";

import { Button } from "@innovationnorway/lighthouse-components";
import { AccountTypeEnum } from "../../../main/models/account-type-enum";
import { SearchOrganizationResult } from "../../../main/models/search-organization-result";
import { useLayout } from "../../hooks/useLayout";
import AccountSearchModal from "../accountSearchModal/accountSearchModal";
import AddAccountModal from "../addAccountModal/addAccountModal";

interface UnverifiedAccount {
  publicId: string;
  accountType: AccountTypeEnum;
  name: string;
}

const AddAccountBySearch = () => {
  const { translations } = useLayout();
  const [unverifiedAccount, setUnverifiedAccount] = useState<UnverifiedAccount>();
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);
  const [showAccountSearchModal, setShowAccountSearchModal] = useState(false);

  const selectAccountFromSearchResult = (account: SearchOrganizationResult) => {
    setUnverifiedAccount({
      publicId: account.orgNumber,
      accountType: AccountTypeEnum.Company,
      name: account.name,
      emailVerified: false
    } as UnverifiedAccount);
    setShowAddAccountModal(true);
    setShowAccountSearchModal(false);
  };

  return (
    <>
      <Button onClick={() => setShowAccountSearchModal(true)} variant="secondary">
        {translations.chooseAccountAddCompanyLabel}
      </Button>
      {showAccountSearchModal && (
        <AccountSearchModal
          selectAccountFromSearchResult={selectAccountFromSearchResult}
          showModal={showAccountSearchModal}
          setShowModal={setShowAccountSearchModal}
        />
      )}
      {showAddAccountModal && unverifiedAccount && (
        <AddAccountModal
          accountPublicId={unverifiedAccount.publicId || ""}
          accountName={unverifiedAccount.name || ""}
          onClose={close}
          showModal={showAddAccountModal}
          setShowModal={setShowAddAccountModal}
        />
      )}
    </>
  );
};
export default AddAccountBySearch;
